import { Spinner } from "@fluentui/react";
import React from "react";

interface ISearchStatusProps {
    runningRealtime?: boolean;
    expandingSearch?: boolean;
}

const SearchStatus: React.FC<ISearchStatusProps> = (props) => {
    if (!props.runningRealtime && !props.expandingSearch) return <></>;
    let label = '';
    if (props.runningRealtime && props.expandingSearch) {
        label = 'Search & Pricing';
    } else if (props.runningRealtime) {
        label = 'Updating Pricing';
    } else if (props.expandingSearch) {
        label = 'Expanding Search';
    }
    return (
        <Spinner
        label={label}
        labelPosition="right"
        />
    );
};

export default SearchStatus;
